export default __webpack_public_path__ + "static/media/number4.ca788e1d.png";